import { Link, NavLink, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Menu, X, LogIn, LogOut, User } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const links = [
  { to: "/", label: "Inicio" },
  { to: "/servicios", label: "Servicios" },
  { to: "/sobre-nosotros", label: "Sobre nosotros" },
  { to: "/blog", label: "Blog" },
  { to: "/contacto", label: "Contacto" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const portalPath = user?.role === "admin" ? "/admin" : "/portal";

  return (
    <header
      data-testid="site-navbar"
      className="fixed top-0 inset-x-0 z-50 bg-black/70 backdrop-blur-xl border-b border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3 group">
          <div className="w-9 h-9 rounded-md border border-[#D4AF37]/60 grid place-items-center font-serif text-[#D4AF37] group-hover:bg-[#D4AF37]/10 transition-colors">
            A
          </div>
          <div className="leading-tight">
            <div className="font-serif text-lg text-white tracking-wide">ANV Asesores</div>
            <div className="text-[10px] uppercase tracking-[0.28em] text-zinc-500">
              Fiscal · Contable · Laboral
            </div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `text-sm tracking-wide transition-colors ${
                  isActive ? "text-[#D4AF37]" : "text-zinc-300 hover:text-white"
                }`
              }
              end={l.to === "/"}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          {user ? (
            <>
              <Link
                to={portalPath}
                data-testid="nav-portal-btn"
                className="text-sm text-zinc-300 hover:text-white flex items-center gap-2"
              >
                <User className="w-4 h-4" /> {user.name?.split(" ")[0] || "Cuenta"}
              </Link>
              <button
                data-testid="nav-logout-btn"
                onClick={async () => {
                  await logout();
                  navigate("/");
                }}
                className="text-sm px-4 py-2 rounded-full border border-white/10 hover:border-white/30 transition-colors flex items-center gap-2"
              >
                <LogOut className="w-4 h-4" /> Salir
              </button>
            </>
          ) : (
            <Link
              to="/login"
              data-testid="nav-login-btn"
              className="text-sm px-5 py-2.5 rounded-full bg-[#D4AF37] text-black font-medium hover:bg-[#FDE047] transition-colors flex items-center gap-2"
            >
              <LogIn className="w-4 h-4" /> Área cliente
            </Link>
          )}
        </div>

        <button
          className="md:hidden text-white"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#0a0a0a] border-t border-white/5 px-6 py-6 flex flex-col gap-4">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `text-base ${isActive ? "text-[#D4AF37]" : "text-zinc-300"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
          {user ? (
            <>
              <Link to={portalPath} onClick={() => setOpen(false)} className="text-base text-white">
                Mi área
              </Link>
              <button
                onClick={async () => {
                  await logout();
                  setOpen(false);
                  navigate("/");
                }}
                className="text-left text-base text-zinc-400"
              >
                Cerrar sesión
              </button>
            </>
          ) : (
            <Link
              to="/login"
              onClick={() => setOpen(false)}
              className="inline-block px-5 py-2.5 rounded-full bg-[#D4AF37] text-black font-medium w-fit"
            >
              Área cliente
            </Link>
          )}
        </div>
      )}
    </header>
  );
}
